/* Alert — colored banner with icon, optional title, and body content.
   Ported from lib/components.jsx (claude_design project 5c0836b6-facf-49dd-9c78-62afe3f7bc12). */

import React from 'react';
import { Icon } from './Icon';
import type { IconName } from './Icon';

export type AlertColor = 'blue' | 'green' | 'amber' | 'red';

export interface AlertProps {
  color?: AlertColor;
  icon?: IconName;
  title?: React.ReactNode;
  children?: React.ReactNode;
}

const DEFAULT_ICON: Record<AlertColor, IconName> = {
  green: 'check-circle',
  amber: 'alert-triangle',
  red: 'alert-triangle',
  blue: 'info',
};

export function Alert({ color = 'blue', icon, title, children }: AlertProps) {
  const iconName = icon ?? DEFAULT_ICON[color];
  return (
    <div className={'alert alert-' + color}>
      <span className="alert-icon">
        <Icon name={iconName} size={17} />
      </span>
      <div>
        {title && <div className="alert-title">{title}</div>}
        {children && (
          <div className="alert-body" style={{ marginTop: title ? 2 : 0 }}>
            {children}
          </div>
        )}
      </div>
    </div>
  );
}

export default Alert;
